import { Injectable, NgModule } from "@angular/core";
import { FiscalCodeHelperComponent } from "src/app/components/ui/fiscal-code-helper/fiscal-code-helper.component";
import { CommonModule } from "@angular/common";
import { DxFormModule } from "devextreme-angular";
import { ButtonModule } from "src/app/components/ui/button/button.module";
import { TranslocoModule } from "@jsverse/transloco";

@NgModule({
  imports: [CommonModule, TranslocoModule, DxFormModule, ButtonModule],
  declarations: [FiscalCodeHelperComponent],
  exports: [FiscalCodeHelperComponent]
})
export class FiscalCodeHelperModule {}
